export default {
    "component_name": "PageSelector",
    "name": "PageSelector",
    "label": "页面选择器",
    "explain": "选择您全局注册到Vue的页面组件(组件注册时提供meta属性, 选项参考(meta: {isPage: true, cn: '页面中文名'}))" // 字段解释
}
